import {FC} from 'react';

import {Typography} from '@mui/material';
import {t} from 'i18next';

import {useAppMode} from 'hooks/useAppMode';
import ReactNative from 'services/react-native';

import {StyledBasketDeliveryInfo} from './styles';

export interface BasketDeliveryInfo1P {
  onClick: () => void;
  message?: string;
  dataTestId?: string;
}

export interface BasketDeliveryInfo3P extends BasketDeliveryInfo1P {
  message: string;
}

export const BasketDeliveryInfo1P: FC<BasketDeliveryInfo1P> = (props) => {
  const {isExpress} = useAppMode();
  const message = isExpress ? props.message : t('label.chooseDeliverySlot');
  const isReactNativeView = ReactNative.isReactNativeWebView();

  return (
    <StyledBasketDeliveryInfo
      onClick={props.onClick}
      withPrices={true}
      data-test-id={props.dataTestId || 'basket_1p_delivery_info'}
      isReactNativeView={isReactNativeView}
    >
      <DeliveryInfo message={message as string} />
    </StyledBasketDeliveryInfo>
  );
};

export const BasketDeliveryInfo3P: FC<BasketDeliveryInfo3P> = (props) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();

  return (
    <StyledBasketDeliveryInfo
      onClick={props.onClick}
      data-test-id={props.dataTestId || 'basket_3p_delivery_info'}
      isReactNativeView={isReactNativeView}
    >
      {t('label.getBy')}: <DeliveryInfo message={props.message} />
    </StyledBasketDeliveryInfo>
  );
};

export const BasketDeliveryInfoBulky: FC<BasketDeliveryInfo3P> = (props) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();
  return (
    <StyledBasketDeliveryInfo
      onClick={props.onClick}
      data-test-id={props.dataTestId || 'basket_bulky_delivery_info'}
      isReactNativeView={isReactNativeView}
    >
      {t('label.getBy')}:
      <Typography className="info" component="div">
        {props.message}
      </Typography>
    </StyledBasketDeliveryInfo>
  );
};

export const BasketDeliveryInfoMakroFleet: FC<BasketDeliveryInfo3P> = (props) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();
  return (
    <StyledBasketDeliveryInfo
      onClick={props.onClick}
      data-test-id={props.dataTestId || 'basket_makro_fleet_delivery_info'}
      isReactNativeView={isReactNativeView}
    >
      <DeliveryInfo message={props.message} />
    </StyledBasketDeliveryInfo>
  );
};

const DeliveryInfo: FC<{message: string}> = ({message}) => (
  <Typography className="info" component="div">
    {message}
  </Typography>
);

BasketDeliveryInfo1P.displayName = 'BasketDeliveryInfo1P';
BasketDeliveryInfo3P.displayName = 'BasketDeliveryInfo';
